import {gql} from 'apollo-boost'

export const GET_CONTRACT_DETAIL = gql`
  query getContractDetail($id: ID!) {
    getContractDetail(
      id: $id
    ) {
      id
      contractDate
      contractLoanDate,
      contractCloseDate,
      contractNo
      contractSeq
      contractName
      contractSeq
      contractAmount
      contractAmountText
      contractStatus
      createdWith
      restructuring
      restructuringTypeName
      createdWithName
      campusName
      contractStatusName
      badDebt,
      badDebtDateShortLocalTh,
      status
      # custom field
      isSignInStudentApp
      restructuringDetail{
        id
        restructuringDateLocalTh
        restructuringFeeRemain
        restructuringPenaltyRemain
        restructuringInterestRemain
        principleRemain
        remark
        contracts{
          id
          contractNo
          contractSeq
          contractName
          # custom field
          contractDateLocalTh
          contractCloseDateLocalTh
        }
      }
      loan {
        restructuringFeeRemain
        restructuringPenaltyRemain
        restructuringInterestRemain
        restructuringPrincipleRemain
        accruedFeeRemain
        accruedPenaltyRemain
        accruedInterestRemain
        accruedPrincipleRemain
        principleRemain
        balanceRemain
        outstandingAmountRemain
        outstandingBalanceRemain
        outstandingBalanceRestructuringRemain
        contractFeeRemain
        taxAmountRemain
        processingFeeRemain
        courtOrderExpenseRemain
        agingNumber
        agingDate
        loanAmount
        interestRate
        penaltyRate
        debtCollectionFeeType
        debtCollectionFeeTypeName
        paymentDescription
        lastUpdate
        interestRateDetails{
          id
          seq
          interestDate
          interestRate
          interestType
          penaltyRate
          penaltyType
          debtCollectionFeeType
          debtCollectionFeeTypeName
          remark
          status
          createdAt
          #custom field
          interestDateLocalTh
        }
        feeDetails{
          id
          seq
          feeDate
          feeType
          amount
          remark
          status
          createdAt
          # custom field
          feeDateLocalTh
          feeTypeName
          createdAtLocalTh
          createByFullName
          processed
        }
        paymentRounds{
          id
          paymentRoundSeq
          paymentRoundInterest
          paymentRoundBalance
          paymentRoundAmount
          paymentRoundAmountRestructuring
          createdAt
          # custom field
          isNextMonth
          paymentRoundDateLocalTh
          paymentRoundTypeName
        }
        payments{
          id
          adjustment
          paymentType
          paymentDate
          paymentAmount
          paymentPrinciple
          paymentRemark
          createdAt
          ## custom fields
          paymentTypeName
          paymentDateLocalTh
          createdAtLocalTh
          createByFullName
          processed
          paymentAmountDetail{
            paidFee
            paidPenalty
            paidInterest
            paidPrinciple
            balanceRemain
          }
        }
        paymentExpenses{
          id
          paymentType
          adjustment
          receiveDate
          paymentDate
          paymentAmount
          paymentContractFee
          paymentTaxAmount
          paymentProcessingFee
          paymentCourtOrderExpense
          paymentRemark
          approvedStatus
          createdAt
          ## custom fields
          paymentTypeName
          paymentDateLocalTh
          createdAtLocalTh
          createByFullName
        }
        expenseDetails{
          id
          expenseType
          expenseDate
          approvedStatus
          amount
          remark
          status
          createdAt
          # custom field
          expenseDateLocalTh
          expenseTypeName
          createdAtLocalTh
          createByFullName
        }
        # custom field
        lastUpdateDateLocalTh
        loanTypeName,
      }
      borrower {
        idCardNumber
        studentCode
        mobile
        phone
        email
        # custom field
        fullName
        facultyCurriculumName
        degreeName
        periodName,
        fullAddress
      }
      suretyDetails {
        id
        seq
        relationshipName
        surety {
          idCardNumber
          mobile
          phone
          email
          # custom field
          fullName
          fullAddress
          borrowerId
        }
      }
      files {
        id
        seq
        description
        fileName
        pathUrl
        ## custom fields
        createdAtLocalTh
        createByFullName
      },
      callHistories{
        id
        seq
        callDate
        remark
        status
        createdAt
        ## custom fields
        callDateLocalTh
        createdAtDateTimeLocalTh
        createdByFullName
      }
      sendSmsHistories{
        id
        seq
        sendDate
        remark
        status
        createdAt
        ## custom fields
        sendDateLocalTh
        createdAtDateTimeLocalTh
        createdByFullName
      }
      sendDocHistories{
        id
        seq
        sendDate
        remark
        status
        createdAt
        ## custom fields
        sendDateLocalTh
        createdAtDateTimeLocalTh
        createdByFullName
      }
      notifications{
        id
        date
        typeName
        title
        description
        isRead
        readAt(local: true, format:"DD/MM/YYYY HH:mm:ss น.")
        approvedStatus
        # custom fields if needed
        dateLocalTh
        createdAtDateTimeLocalTh
        createdByFullName
      }
      # custom field
      callHistoriesReceivedStatus
      callHistoriesReceivedAtDateTimeLocalTh
      callHistoriesReceivedDateTimeLocalTh
      callHistoriesReceivedBy {
        id
        fullName
      }
      contractSummarizeStatus
      username
      contractDateLocalTh
      facultyCurriculumName
      projectName
      periodStartEnd
      transferSchedules  {
        id
        date
        loanDetailType
        amount
        transferId
        transferDate
        transferLoanDetailType
        transferAmount
        transferProcessed
        transferRemark
      }
    }
  }
`

export const GET_CONTRACT_DETAIL_TRANSFER_SCHEDULES = gql`
  query getContractDetail($id: ID!) {
    getContractDetail(
      id: $id
    ) {
      transferSchedules  {
        id
        date
        loanDetailType
        amount
        transferId
        transferDate
        transferLoanDetailType
        transferAmount
        transferProcessed
        transferRemark
      }
    }
  }
`

export const CALCULATE_CONTRACT_DETAIL = gql`
  mutation reGenerateTransactions($contractId: ID!, $updateToNow: Boolean!, $updateToDate: String, $index: Int) {
    reGenerateTransactions(
      contractId: $contractId,
      updateToNow: $updateToNow,
      updateToDate: $updateToDate,
      index: $index
    ) {
      count
    }
  }
`

// borrower
export const GET_CONTRACT_DETAIL_BORROWER = gql`
  query getContractDetailBorrower($contractId: ID!) {
    getContractDetailBorrower(
      contractId: $contractId
    ) {
      idCardNumber
      studentCode
      mobile
      phone
      email
      # custom field
      fullName
      facultyCurriculumName
      degreeName
      periodName,
      fullAddress
    }
  }
`

// surety details
export const CREATE_CONTRACT_DETAIL_SURETY_DETAIL = gql`
  mutation createContractDetailSuretyDetail($contractId: ID!, $input: SuretyDetailInput!) {
    createContractDetailSuretyDetail(
      contractId: $contractId
      input: $input
    ){
      id
      seq
      relationshipId
      relationshipName
      surety {
        idCardNumber
        mobile
        phone
        email
        # custom field
        fullName
        fullAddress
        borrowerId
      }
    }
  }
`

export const DELETE_CONTRACT_DETAIL_SURETY_DETAIL = gql`
  mutation deleteContractDetailSuretyDetail($id: ID!) {
    deleteContractDetailSuretyDetail(
      id: $id
    ) {
      id
    }
  }
`

// files
export const CREATE_CONTRACT_DETAIL_FILE = gql`
  mutation createContractDetailFile($contractId: ID!, $input: FileInput!) {
    createContractDetailFile(
      contractId: $contractId
      input: $input
    ){
      id
      seq
      description
      fileName
      pathUrl
      ## custom fields
      createdAtLocalTh
      createByFullName
    }
  }
`

export const DELETE_CONTRACT_DETAIL_FILE = gql`
  mutation deleteContractDetailFile($id: ID!) {
    deleteContractDetailFile(
      id: $id
    ) {
      id
    }
  }
`

// call histories
export const CREATE_CONTRACT_DETAIL_CALL_HISTORY = gql`
  mutation createContractDetailCallHistory($contractId: ID!, $input: CallHistoryInput!) {
    createContractDetailCallHistory(
      contractId: $contractId
      input: $input
    ){
      id
      seq
      callDate
      remark
      status
      createdAt
      ## custom fields
      callDateLocalTh
      createdAtDateTimeLocalTh
      createdByFullName
    }
  }
`

export const DELETE_CONTRACT_DETAIL_CALL_HISTORY = gql`
  mutation deleteContractDetailCallHistory($id: ID!) {
    deleteContractDetailCallHistory(
      id: $id
    ) {
      id
    }
  }
`

export const RECEIVE_CONTRACT_DETAIL_CALL_HISTORY = gql`
  mutation receiveContractDetailCallHistory($contractId: ID!) {
    receiveContractDetailCallHistory(
      contractId: $contractId
    ) {
      callHistoriesReceivedStatus
      callHistoriesReceivedAtDateTimeLocalTh
      callHistoriesReceivedDateTimeLocalTh
      callHistoriesReceivedBy {
        id
        fullName
      }
    }
  }
`

export const UN_RECEIVE_CONTRACT_DETAIL_CALL_HISTORY = gql`
  mutation unReceiveContractDetailCallHistory($contractId: ID!) {
    unReceiveContractDetailCallHistory(
      contractId: $contractId
    ) {
      callHistoriesReceivedStatus
      callHistoriesReceivedAtDateTimeLocalTh
      callHistoriesReceivedDateTimeLocalTh
      callHistoriesReceivedBy {
        id
        fullName
      }
    }
  }
`

// send sms histories
export const CREATE_CONTRACT_DETAIL_SEND_SMS_HISTORY = gql`
  mutation createContractDetailSendSmsHistory($contractId: ID!, $input: SendSmsHistoryInput!) {
    createContractDetailSendSmsHistory(
      contractId: $contractId
      input: $input
    ){
      id
      seq
      sendDate
      remark
      status
      createdAt
      ## custom fields
      sendDateLocalTh
      createdAtDateTimeLocalTh
      createdByFullName
    }
  }
`

export const DELETE_CONTRACT_DETAIL_SEND_SMS_HISTORY = gql`
  mutation deleteContractDetailSendSmsHistory($id: ID!) {
    deleteContractDetailSendSmsHistory(
      id: $id
    ) {
      id
    }
  }
`

// send doc histories
export const CREATE_CONTRACT_DETAIL_SEND_DOC_HISTORY = gql`
  mutation createContractDetailSendDocHistory($contractId: ID!, $input: SendDocHistoryInput!) {
    createContractDetailSendDocHistory(
      contractId: $contractId
      input: $input
    ){
      id
      seq
      sendDate
      remark
      status
      createdAt
      ## custom fields
      sendDateLocalTh
      createdAtDateTimeLocalTh
      createdByFullName
    }
  }
`

export const DELETE_CONTRACT_DETAIL_SEND_DOC_HISTORY = gql`
  mutation deleteContractDetailSendDocHistory($id: ID!) {
    deleteContractDetailSendDocHistory(
      id: $id
    ) {
      id
    }
  }
`

// notifications
export const CREATE_CONTRACT_DETAIL_NOTIFICATION = gql`
  mutation createContractDetailNotification($contractId: ID!, $input: NotificationInput!) {
    createContractDetailNotification(
      contractId: $contractId
      input: $input
    ) {
      id
      date
      typeName
      title
      description
      isRead
      readAt(local: true, format:"DD/MM/YYYY HH:mm:ss น.")
      approvedStatus
      # custom fields if needed
      dateLocalTh
      createdAtDateTimeLocalTh
      createdByFullName
    }
  }
`

export const UPDATE_CONTRACT_DETAIL_NOTIFICATION = gql`
  mutation updateContractDetailNotification($id: ID!, $input: NotificationInput!) {
    updateContractDetailNotification(
      id: $id
      input: $input
    ) {
      id
      date
      typeName
      title
      description
      isRead
      readAt(local: true, format:"DD/MM/YYYY HH:mm:ss น.")
      approvedStatus
      # custom fields if needed
      dateLocalTh
      createdAtDateTimeLocalTh
      createdByFullName
    }
  }
`

export const APPROVED_CONTRACT_DETAIL_NOTIFICATION = gql`
  mutation approvedContractDetailNotification($id: ID!) {
    approvedContractDetailNotification(
      id: $id
    ) {
      id
      date
      typeName
      title
      description
      isRead
      readAt(local: true, format:"DD/MM/YYYY HH:mm:ss น.")
      approvedStatus
      # custom fields if needed
      dateLocalTh
      createdAtDateTimeLocalTh
      createdByFullName
    }
  }
`

export const CANCEL_CONTRACT_DETAIL_NOTIFICATION = gql`
  mutation cancelContractDetailNotification($id: ID!) {
    cancelContractDetailNotification(
      id: $id
    ) {
      id
      date
      typeName
      title
      description
      isRead
      readAt(local: true, format:"DD/MM/YYYY HH:mm:ss น.")
      approvedStatus
      # custom fields if needed
      dateLocalTh
      createdAtDateTimeLocalTh
      createdByFullName
    }
  }
`

export const DELETE_CONTRACT_DETAIL_NOTIFICATION = gql`
  mutation deleteContractDetailNotification($id: ID!) {
    deleteContractDetailNotification(
      id: $id
    ) {
      id
    }
  }
`

// fee details
export const CREATE_CONTRACT_DETAIL_FEE_DETAIL = gql`
  mutation createContractDetailFeeDetail($contractId: ID!, $input: FeeDetailInput!) {
    createContractDetailFeeDetail(
      contractId: $contractId
      input: $input
    ){
      id
      seq
      feeDate
      feeType
      amount
      remark
      status
      createdAt
      # custom field
      feeDateLocalTh
      feeTypeName
      createdAtLocalTh
      createByFullName
      processed
    }
  }
`

export const UPDATE_CONTRACT_DETAIL_FEE_DETAIL = gql`
  mutation updateContractDetailFeeDetail($id: ID!, $input: FeeDetailInput!) {
    updateContractDetailFeeDetail(
      id: $id
      input: $input
    ){
      id
      seq
      feeDate
      feeType
      amount
      remark
      status
      createdAt
      # custom field
      feeDateLocalTh
      feeTypeName
      createdAtLocalTh
      createByFullName
      processed
    }
  }
`

export const DELETE_CONTRACT_DETAIL_FEE_DETAIL = gql`
  mutation deleteContractDetailFeeDetail($id: ID!) {
    deleteContractDetailFeeDetail(
      id: $id
    ) {
      id
    }
  }
`

export const CALCULATE_CONTRACT_DETAIL_FEE_DETAIL = gql`
  mutation reGenerateTransactions($contractId: ID!, $updateToNow: Boolean!, $updateToDate: String, $index: Int) {
    reGenerateTransactions(
      contractId: $contractId,
      updateToNow: $updateToNow,
      updateToDate: $updateToDate,
      index: $index
    ) {
      count
    }
  }
`

// expense details
export const CREATE_CONTRACT_DETAIL_EXPENSE_DETAIL = gql`
  mutation createContractDetailExpenseDetail($contractId: ID!, $input: ExpenseDetailInput!) {
    createContractDetailExpenseDetail(
      contractId: $contractId
      input: $input
    ){
      id
      expenseType
      expenseDate
      approvedStatus
      amount
      remark
      status
      createdAt
      # custom field
      expenseDateLocalTh
      expenseTypeName
      createdAtLocalTh
      createByFullName
    }
  }
`

export const UPDATE_CONTRACT_DETAIL_EXPENSE_DETAIL = gql`
  mutation updateContractDetailExpenseDetail($id: ID!, $input: ExpenseDetailInput!) {
    updateContractDetailExpenseDetail(
      id: $id
      input: $input
    ){
      id
      expenseType
      expenseDate
      approvedStatus
      amount
      remark
      status
      createdAt
      # custom field
      expenseDateLocalTh
      expenseTypeName
      createdAtLocalTh
      createByFullName
    }
  }
`

export const APPROVED_CONTRACT_DETAIL_EXPENSE_DETAIL = gql`
  mutation approvedContractDetailExpenseDetail($id: ID!) {
    approvedContractDetailExpenseDetail(
      id: $id
    ) {
      id
      expenseType
      expenseDate
      approvedStatus
      amount
      remark
      status
      createdAt
      # custom field
      expenseDateLocalTh
      expenseTypeName
      createdAtLocalTh
      createByFullName
    }
  }
`

export const CANCELED_CONTRACT_DETAIL_EXPENSE_DETAIL = gql`
  mutation canceledContractDetailExpenseDetail($id: ID!) {
    canceledContractDetailExpenseDetail(
      id: $id
    ) {
      id
      expenseType
      expenseDate
      approvedStatus
      amount
      remark
      status
      createdAt
      # custom field
      expenseDateLocalTh
      expenseTypeName
      createdAtLocalTh
      createByFullName
    }
  }
`

export const DELETE_CONTRACT_DETAIL_EXPENSE_DETAIL = gql`
  mutation deleteContractDetailExpenseDetail($id: ID!) {
    deleteContractDetailExpenseDetail(
      id: $id
    ) {
      id
    }
  }
`

// payments
export const CREATE_CONTRACT_DETAIL_PAYMENT = gql`
  mutation createContractDetailPayment($contractId: ID!, $input: PaymentInput!) {
    createContractDetailPayment(
      contractId: $contractId
      input: $input
    ){
      id
      adjustment
      paymentType
      paymentDate
      paymentAmount
      paymentPrinciple
      paymentRemark
      createdAt
      ## custom fields
      paymentTypeName
      paymentDateLocalTh
      createdAtLocalTh
      createByFullName
      processed
      paymentAmountDetail{
        paidFee
        paidPenalty
        paidInterest
        paidPrinciple
        balanceRemain
      }
    }
  }
`

export const UPDATE_CONTRACT_DETAIL_PAYMENT = gql`
  mutation updateContractDetailPayment($id: ID!, $input: PaymentInput!) {
    updateContractDetailPayment(
      id: $id
      input: $input
    ){
      id
      adjustment
      paymentType
      paymentDate
      paymentAmount
      paymentPrinciple
      paymentRemark
      createdAt
      ## custom fields
      paymentTypeName
      paymentDateLocalTh
      createdAtLocalTh
      createByFullName
      processed
      paymentAmountDetail{
        paidFee
        paidPenalty
        paidInterest
        paidPrinciple
        balanceRemain
      }
    }
  }
`

export const DELETE_CONTRACT_DETAIL_PAYMENT = gql`
  mutation deleteContractDetailPayment($id: ID!) {
    deleteContractDetailPayment(
      id: $id
    ) {
      id
    }
  }
`

export const CALCULATE_CONTRACT_DETAIL_PAYMENT = gql`
  mutation reGenerateTransactions($contractId: ID!, $updateToNow: Boolean!, $updateToDate: String, $index: Int) {
    reGenerateTransactions(
      contractId: $contractId,
      updateToNow: $updateToNow,
      updateToDate: $updateToDate,
      index: $index
    ) {
      count
    }
  }
`

// payment expenses
export const CREATE_CONTRACT_DETAIL_PAYMENT_EXPENSE = gql`
  mutation createContractDetailPaymentExpense($contractId: ID!, $input: PaymentExpenseInput!) {
    createContractDetailPaymentExpense(
      contractId: $contractId
      input: $input
    ){
      id
      paymentType
      adjustment
      receiveDate
      paymentDate
      paymentAmount
      paymentContractFee
      paymentTaxAmount
      paymentProcessingFee
      paymentCourtOrderExpense
      paymentRemark
      approvedStatus
      createdAt
      ## custom fields
      paymentTypeName
      paymentDateLocalTh
      createdAtLocalTh
      createByFullName
    }
  }
`

export const UPDATE_CONTRACT_DETAIL_PAYMENT_EXPENSE = gql`
  mutation updateContractDetailPaymentExpense($id: ID!, $input: PaymentExpenseInput!) {
    updateContractDetailPaymentExpense(
      id: $id
      input: $input
    ){
      id
      paymentType
      adjustment
      receiveDate
      paymentDate
      paymentAmount
      paymentContractFee
      paymentTaxAmount
      paymentProcessingFee
      paymentCourtOrderExpense
      paymentRemark
      approvedStatus
      createdAt
      ## custom fields
      paymentTypeName
      paymentDateLocalTh
      createdAtLocalTh
      createByFullName
    }
  }
`

export const APPROVED_CONTRACT_DETAIL_PAYMENT_EXPENSE = gql`
  mutation approvedContractDetailPaymentExpense($id: ID!) {
    approvedContractDetailPaymentExpense(
      id: $id
    ) {
      id
      paymentType
      adjustment
      receiveDate
      paymentDate
      paymentAmount
      paymentContractFee
      paymentTaxAmount
      paymentProcessingFee
      paymentCourtOrderExpense
      paymentRemark
      approvedStatus
      createdAt
      ## custom fields
      paymentTypeName
      paymentDateLocalTh
      createdAtLocalTh
      createByFullName
    }
  }
`

export const CANCELED_CONTRACT_DETAIL_PAYMENT_EXPENSE = gql`
  mutation canceledContractDetailPaymentExpense($id: ID!) {
    canceledContractDetailPaymentExpense(
      id: $id
    ) {
      id
      paymentType
      adjustment
      receiveDate
      paymentDate
      paymentAmount
      paymentContractFee
      paymentTaxAmount
      paymentProcessingFee
      paymentCourtOrderExpense
      paymentRemark
      approvedStatus
      createdAt
      ## custom fields
      paymentTypeName
      paymentDateLocalTh
      createdAtLocalTh
      createByFullName
    }
  }
`

export const DELETE_CONTRACT_DETAIL_PAYMENT_EXPENSE = gql`
  mutation deleteContractDetailPaymentExpense($id: ID!) {
    deleteContractDetailPaymentExpense(
      id: $id
    ) {
      id
    }
  }
`

// transfer schedules
export const CREATE_CONTRACT_DETAIL_TRANSFER_SCHEDULE = gql`
  mutation createContractDetailTransferSchedule($contractId: ID!, $input: TransferScheduleInput!) {
    createContractDetailTransferSchedule(
      contractId: $contractId
      input: $input
    ){
      id
      date
      loanDetailType
      amount
      transferId
      transferDate
      transferLoanDetailType
      transferAmount
      transferProcessed
      transferRemark
      createdAt
    }
  }
`

export const DELETE_CONTRACT_DETAIL_TRANSFER_SCHEDULE = gql`
  mutation deleteContractDetailTransferSchedule($id: ID!, $type: String!) {
    deleteContractDetailTransferSchedule(
      id: $id
      type: $type
    ) {
      count
    }
  }
`

// payment rounds
export const CREATE_CONTRACT_DETAIL_PAYMENT_ROUNDS = gql`
  mutation createContractDetailPaymentRounds($contractId: ID!, $input: PaymentRoundsInput!) {
    createContractDetailPaymentRounds(
      contractId: $contractId
      input: $input
    ){
      id
      paymentRoundSeq
      paymentRoundInterest
      paymentRoundBalance
      paymentRoundAmount
      paymentRoundAmountRestructuring
      createdAt
      # custom field
      isNextMonth
      paymentRoundDateLocalTh
      paymentRoundTypeName
    }
  }
`

export const DELETE_CONTRACT_DETAIL_PAYMENT_ROUNDS = gql`
  mutation deleteContractDetailPaymentRounds($id: ID!) {
    deleteContractDetailPaymentRounds(
      id: $id
    ) {
      count
    }
  }
`




